import { apiRequest, clearAdminSession, hasAdminSession, setAdminSession } from './apiClient';

export function isAdminAuthenticated() {
  return hasAdminSession() && !!sessionStorage.getItem('ct_admin_api_token');
}

export async function loginAdmin(password) {
  try {
    const payload = await apiRequest({
      resource: 'auth',
      action: 'login',
      method: 'POST',
      body: { password }
    });
    
    if (payload.token) {
      sessionStorage.setItem('ct_admin_api_token', payload.token);
      setAdminSession();
      return true;
    }
    return false;
  } catch (error) {
    throw new Error(error.message || 'Contraseña incorrecta');
  }
}

export function logoutAdmin() {
  clearAdminSession();
  sessionStorage.removeItem('ct_admin_api_token');
}
